import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    InjectionToken,
    Input,
    OnDestroy,
    Output,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';

export const MENU_PANEL = new InjectionToken<MenuPanel>('MENU_PANEL');

export interface MenuPanel {
    xPosition: 'before' | 'after' | 'center';
    yPosition: 'above' | 'below';
    templateRef: TemplateRef<unknown>;
    panelClass?: string | string[];
    readonly panelId?: string;
    readonly close: EventEmitter<void>;
    readonly opened: EventEmitter<void>;
}

@Component({
    selector: 'nw-menu',
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'nwMenu',
    providers: [{ provide: MENU_PANEL, useExisting: MenuComponent }],
    encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements MenuPanel, OnDestroy {
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('class') panelClass?: string | string[];
    @Input() xPosition: 'before' | 'after' | 'center' = 'after';
    @Input() yPosition: 'above' | 'below' = 'below';

    @Output() readonly closed: EventEmitter<void> = new EventEmitter<void>();
    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() readonly close: EventEmitter<void> = this.closed;
    @Output() readonly opened: EventEmitter<void> = new EventEmitter<void>();

    @ViewChild(TemplateRef) templateRef!: TemplateRef<unknown>;

    readonly panelId = `nw-menu-panel`;

    public ngOnDestroy(): void {
        this.closed.emit();
        this.closed.complete();
    }
}
